import { TonClient } from '@ton/ton'
import { useAsyncInitialize } from './useAsyncInitialize'
import { useTonConnect } from './useTonConnect'
import { isMainnet } from '../shared/utils/network'

export function useTonClient() {
  const { network } = useTonConnect()

  return {
    client: useAsyncInitialize(async () => {
      return new TonClient({
        endpoint: isMainnet(network)
          ? 'https://toncenter.com/api/v2/jsonRPC'
          : 'https://testnet.toncenter.com/api/v2/jsonRPC',
      })
    }, [network]),
  }
}
